import { Action } from '../../actions';
import {
    OPEN_CREATIVE_CONSTRUCTOR,
    OPEN_CREATIVE_CONSTRUCTOR_PRESETS,
    OPEN_CREATIVE_HTML5_CONSTRUCTOR,
    UPDATE_BANNER_CREATIVE_DATA,
    UpdateBannerCreativeData
} from '../../actions/creative';
import {
    EditBannersState,
    getEditedBannerWithCreative,
    MassActionId
} from '../../typings/bannersEditState';
import { State } from '../../typings/state';
import { EditBannersInitialState } from '../bannersEdit';

const updateBannerCreativeData = (
    state: EditBannersState,
    action: UpdateBannerCreativeData
): EditBannersState => {
    const banner = getEditedBannerWithCreative(state.banners[action.bannerId]);

    if (!banner) {
        return state;
    }

    return {
        ...state,
        banners: {
            ...state.banners,
            [action.bannerId]: {
                ...banner,
                errors: {
                    ...banner.errors,
                    creativeId: {
                        errors: []
                    }
                }
            }
        }
    };
};

export function creativeReducer(
    state: EditBannersState = EditBannersInitialState,
    action: Action,
    fullState: State
): EditBannersState {
    switch (action.type) {
        case OPEN_CREATIVE_HTML5_CONSTRUCTOR:
        case OPEN_CREATIVE_CONSTRUCTOR:
        case OPEN_CREATIVE_CONSTRUCTOR_PRESETS:
            return {
                ...state,
                canvasModal: {
                    ...state.canvasModal,
                    sharedData: {
                        ...action.sharedData
                    }
                }
            };

        case UPDATE_BANNER_CREATIVE_DATA:
            return action.bannerId === MassActionId.bannersEdit
                ? state
                : updateBannerCreativeData(state, action);

        default:
            return state;
    }
}
